import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { useSeo } from '../hooks/useSeo';
import { Logo } from '../components/ui/Logo';
import { FicheTPPanel, CertifTPPanel, FicheBTSPanel, CertifBTSPanel, ModalitesAccessPanel } from '../components/CataloguePanels';
export function Catalogue() {
  useScreenInit();
  useSeo({
    title: 'Catalogue de formation 2026-2027',
    description: 'Consultez le catalogue de formation de Zillenium Alternance : fiches détaillées du BTS NDRC et des titres professionnels Conseiller de Vente et Négociateur Technico-Commercial, certifications et modalités d’accès.',
    path: '/catalogue'
  });
  return <div className="flex flex-col w-full bg-muted min-h-screen pb-24" data-id="element-1003" data-mp="10wex7wyqqcuu">
      <div className="container max-w-6xl mx-auto py-12 space-y-16" data-id="element-1004" data-mp="15xuhvnx0ahcp">
        {/* Page 1: Cover */}
        <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-1005" data-mp="ry39c2p9dt63">
          <div className="h-28 flex items-center justify-center bg-white shrink-0" data-id="element-1006" data-mp="vy3mlk0mfybk">
            <div className="scale-[1.7] origin-center" data-id="element-1007" data-mp="38hfpauwjpo6a">
              <Logo data-id="element-1008" data-mp="38k1yeyz34bqm" />
            </div>
          </div>
          <div className="flex-1 flex" data-id="element-1009" data-mp="33huhrw3b87hy">
            <div className="w-[55%] bg-primary-dark p-12 flex flex-col justify-center text-white relative" data-id="element-1010" data-mp="33kyrf8zjnvg0">
              <div className="inline-block bg-brand-orange text-white font-heading font-bold px-4 py-2 text-sm tracking-wider mb-8 w-fit" data-id="element-1011" data-mp="3idsjdtw0641k">
                CATALOGUE DE FORMATIONS EN ALTERNANCE
              </div>
              <h1 className="text-5xl md:text-6xl font-heading font-extrabold leading-tight mb-8" data-id="element-1012" data-mp="2ksec6ucrpouo">
                CATALOGUE
                <br data-id="element-1013" data-mp="2zhix4jay676h" />
                FORMATIONS
                <br data-id="element-1014" data-mp="2zjdly8pcajfu" />
                2026
              </h1>
              <p className="text-xl font-medium leading-relaxed max-w-md" data-id="element-1015" data-mp="2upj2959qi4gr">
                Deux parcours professionnalisants en alternance, avec une
                information publique détaillée, vérifiable et accessible.
              </p>
            </div>
            <div className="w-[45%] bg-lavande p-12 flex items-center justify-center" data-id="element-1016" data-mp="2rq0q63s6ptye">
              <div className="bg-white p-10 w-full shadow-lg" data-id="element-1017" data-mp="2ro7svf3gom32">
                <h2 className="text-2xl font-heading font-extrabold text-primary-dark mb-8" data-id="element-1018" data-mp="2vq2ukkpb11hd">
                  SESSIONS OUVERTES
                </h2>
                <div className="space-y-6 mb-8" data-id="element-1019" data-mp="35h5vnmi8hggn">
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-1020" data-mp="35gxidti7894x">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-1021" data-mp="28ryaiflj19d9">
                      BTS NDRC
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-1022" data-mp="2ct9yyhsnzojv">
                      Session 2026–2028
                    </p>
                  </div>
                  <div className="border-l-4 border-brand-orange pl-4" data-id="element-1023" data-mp="2mrh3g15roe4z">
                    <h3 className="text-xl font-bold text-primary-dark" data-id="element-1024" data-mp="2mol6og5nnvi4">
                      TP Conseiller de Vente
                    </h3>
                    <p className="text-primary-dark font-medium" data-id="element-1025" data-mp="1zxcmzbrsakc">
                      Session 2026–2027
                    </p>
                  </div>
                </div>
                <p className="text-sm text-primary-dark font-medium leading-relaxed" data-id="element-1026" data-mp="1hjy2kmv3pa32">
                  Rentrée prévisionnelle : 25 septembre 2026, sous réserve de
                  places disponibles et de signature du contrat d'apprentissage.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-primary-dark border-t border-white/10 p-6 text-center text-white shrink-0" data-id="element-1027" data-mp="13sjisdtdd4uy">
            <p className="font-medium" data-id="element-1028" data-mp="ysx2twm5paig">
              Zillenium Alternance • 25 rue Gabriel Cortel – 89300 Joigny
              <br data-id="element-1029" data-mp="tuvael2ubyub" />
              09 83 49 01 81 • contact@zilleniumalternance.fr
            </p>
          </div>
        </div>

        {/* Page 2: Repères */}
        <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-1030" data-mp="2o7uxez9jvvbm">
          <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-1031" data-mp="2o5qvunz4j8ei">
            <div data-id="element-1032" data-mp="2j6xeulkmoz9l">
              <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-1033" data-mp="2r9pxm3k60slt">
                INFORMATION PUBLIQUE AVANT INSCRIPTION
              </p>
              <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-1034" data-mp="2w8aovdhfw1y4">
                REPÈRES CANDIDATS ET ENTREPRISES
              </h2>
            </div>
            <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-1035" data-mp="2m9tu05fdr36s">
              Catalogue 2026
            </div>
          </div>
          <div className="flex-1 flex p-8 gap-8" data-id="element-1036" data-mp="28hx5ebcx7bf5">
            <div className="w-1/2 flex flex-col" data-id="element-1037" data-mp="2dagjd9fis8kh">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-1038" data-mp="2db9ibo88lts2">
                OFFRE PUBLIÉE
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-1039" data-mp="23jvlxpbl1a35">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur les sessions confirmées.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-1040" data-mp="1tmh71u5b4tcy">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1041" data-mp="1tnsattyr6142">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1042" data-mp="1axx9cwof8ix0">
                    FORMATIONS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1043" data-mp="160x3omvhhi6f">
                    TP Conseiller de Vente 2026–2027 ; BTS NDRC 2026–2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1044" data-mp="1exxn0f3p4q30">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1045" data-mp="1tv86obqht29t">
                    PUBLIC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1046" data-mp="1ox6f12f03umq">
                    Candidats en alternance, entreprises d'accueil et
                    prescripteurs.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1047" data-mp="1ypccusrxp69u">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1048" data-mp="2cnirmql6yfjn">ACCÈS</div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1049" data-mp="27oz62raif5rt">
                    Candidature, entretien, positionnement, validation du projet
                    et contrat.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1050" data-mp="19cmt2m0e1dhv">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1051" data-mp="1ea55imdm6aum">
                    TARIF APPRENTI
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1052" data-mp="1j37sgbnvym1u">
                    0 € pour l'apprenti sous contrat, financement selon OPCO.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1053" data-mp="1syrnywyjfiq2">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1054" data-mp="1x1fw12ffgllz">
                    RYTHME
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1055" data-mp="21zhafa1wrwr4">
                    Alternance école / entreprise, modalités précisées dans
                    chaque fiche.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1056" data-mp="7mzvcpr842xk">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1057" data-mp="40fgu2z0tiy">
                    MOYENS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1058" data-mp="3rglcjalgm60d">
                    Cours, ateliers, cas pratiques, mises en situation et suivi
                    individualisé.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-1059" data-mp="j1ui8qdia8sw">
                <span className="text-brand-orange font-bold" data-id="element-1060" data-mp="e301rv30gwby">
                  Avant l'entrée en formation :
                </span>{' '}
                le candidat reçoit le programme, les modalités d'accès, les
                prérequis, les conditions tarifaires, les contacts utiles et les
                informations relatives à la certification visée.
              </div>
            </div>
            <div className="w-1/2 flex flex-col" data-id="element-1061" data-mp="2psk81umsbdow">
              <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-1062" data-mp="2prrc7opd68lj">
                CERTIFICATION ET RÉSULTATS
              </h3>
              <p className="text-primary-dark font-bold mb-6" data-id="element-1063" data-mp="xqzm8l9yx42h">
                Chaque fiche mentionne la certification professionnelle visée,
                ses blocs et le lien officiel vérifiable.
              </p>
              <div className="flex-1 flex flex-col gap-1 text-sm" data-id="element-1064" data-mp="opt5qc7bjt98">
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1065" data-mp="os5up9bhv3vs">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1066" data-mp="1cgp3rr2dbkox">
                    TP VENTE
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1067" data-mp="1gjbshj3qsphw">
                    RNCP37098, niveau 4, Ministère chargé de l'emploi, échéance
                    25/01/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1068" data-mp="1vf1evicub4n5">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1069" data-mp="1vcx025dekl83">
                    BTS NDRC
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1070" data-mp="29k1nl33v137a">
                    RNCP38368, niveau 5, Ministère chargé de l'enseignement
                    supérieur, échéance 31/12/2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1071" data-mp="2j8s0ha0fubl2">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1072" data-mp="2eaqhep30ic9l">
                    RÉSULTATS TP
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1073" data-mp="1qm7c8if9eflq">
                    Session 2024–2025 : 100 %. Session 2026–2027 : examen à
                    venir.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1074" data-mp="20l6jbwkdm36m">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1075" data-mp="1vjh5ya9oldfd">
                    RÉSULTATS BTS
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1076" data-mp="3bwxms17548n0">
                    Sessions 2025–2027 et 2026–2028 : examens prévus en 2027 et
                    2028.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1077" data-mp="1zr58daewq9ir">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1078" data-mp="1uqhk2wi2c6s8">
                    ACCESSIBILITÉ
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1079" data-mp="1pwwjqxszz0pv">
                    Étude individualisée des besoins et adaptation possible du
                    parcours.
                  </div>
                </div>
                <div className="flex border-b border-primary/20 pb-2 mb-2" data-id="element-1080" data-mp="1bzhtjqux6owu">
                  <div className="w-1/3 font-bold text-primary-dark" data-id="element-1081" data-mp="1c1krcx2bdmc4">
                    MISE À JOUR
                  </div>
                  <div className="w-2/3 text-primary-dark" data-id="element-1082" data-mp="121k26uhrkc00">
                    Les indicateurs sont actualisés après les sessions
                    réellement présentées.
                  </div>
                </div>
              </div>
              <div className="bg-primary-dark text-white p-4 mt-4 text-sm font-medium" data-id="element-1083" data-mp="2wgmq4nr5zm0t">
                <span className="text-brand-orange font-bold" data-id="element-1084" data-mp="34valomlkj8xa">Contacts :</span>{' '}
                09 83 49 01 81 • contact@zilleniumalternance.fr • Référent
                handicap : samir@zilleniumalternance.fr.
              </div>
            </div>
          </div>
          <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-1085" data-mp="3inh126gwdbvo">
            <p data-id="element-1086" data-mp="2lxhjxnmol51h">
              Zillenium Alternance • 25 rue Gabriel Cortel, 89300 Joigny •
              Catalogue public des formations en alternance
            </p>
          </div>
        </div>

        {/* Page 3: Fiche TP */}
        <FicheTPPanel data-id="element-1087" data-mp="2uxwe7chmhuh4" />

        {/* Page 4: Certif TP */}
        <CertifTPPanel data-id="element-1088" data-mp="2v0imjecc8e0e" />

        {/* Page 5: Fiche BTS */}
        <FicheBTSPanel data-id="element-1089" data-mp="2zy23wn4c16wk" />

        {/* Page 6: Certification BTS NDRC */}
        <CertifBTSPanel data-id="element-1090" data-mp="a8qanxc2dyth" />

        {/* Page 7: Modalités d'accès */}
        <ModalitesAccessPanel data-id="element-1091" data-mp="f71ki82d09bp" />
      </div>
    </div>;
}